import React from 'react'
import { ShippingAddressDisplay } from './ShippingAddressDisplay'
import { Box, HorizontalStack, LoadingPlaceholder, ShowIf } from '@ztechapps/webui.util'
import { formatMoney } from '@ztechapps/common.utils'
import { Stack } from 'react-bootstrap'
import isEmpty from 'lodash/isEmpty'
import { useCheckoutContext } from './index'

export const Summary = () => {
  // const shippingOptions = useDataValue(shippingOptionsData)
  // const { document, loading } = useDataValue(orderDocumentData)
  // const hasAddress = useDataValue(hasAddressData)
  // const net = useDataValue(netData)
  // const shippingFee = useDataValue(shippingFeeData)
  // const isManualShippingRate = useDataValue(isManualShippingRateData)
  const { shippingOptions: shippingOptionsBase, orderDocumentResult, hasAddress, orderNetAmount } = useCheckoutContext()

  const { document, loading } = orderDocumentResult
  const [shippingOptions] = shippingOptionsBase
  const shippingFee = shippingOptions.shippingFee
  const isManualShippingRate = shippingOptions.isManualShippingRate
  const carrierRate = shippingOptions.carrierRate
  const net = orderNetAmount
  const customerPoNumber = shippingOptions.customerPoNumber

  return (
    <Box>
      <Box.Header>
        <div className="w-100">
          <LoadingPlaceholder loading={loading}>
            <div className={'d-flex justify-content-between'}>
              <div>
                <h4>#{document?.code}</h4>
              </div>
              <div>
                <h4>{document?.status}</h4>
              </div>
            </div>

            <small>Here is your order summary, please review the amount and delivery address if it correct.</small>
          </LoadingPlaceholder>
        </div>
      </Box.Header>
      <Box.Body>
        <hr />

        <Stack gap={2}>
          <HorizontalStack className="justify-content-between">
            <div>Subtotal:</div>
            <strong>{formatMoney(document?.gross)}</strong>
          </HorizontalStack>
          <HorizontalStack className="justify-content-between">
            <div>Shipping:</div>

            <div>
              <Stack className="text-end">
                <strong>{formatMoney(shippingFee)}</strong>
                <ShowIf condition={!isManualShippingRate}>
                  <small>{carrierRate?.serviceType ?? ''}</small>
                </ShowIf>
              </Stack>
            </div>
          </HorizontalStack>
          <HorizontalStack className="justify-content-between">
            <div>Tax Amount:</div>
            <strong>{formatMoney(document?.taxAmount)}</strong>
          </HorizontalStack>
          <HorizontalStack className="justify-content-between">
            <div>Discount:</div>
            <strong>{formatMoney(document?.discount)}</strong>
          </HorizontalStack>
          <HorizontalStack className="justify-content-between">
            <div>Total:</div>
            <strong>{formatMoney(net)}</strong>
          </HorizontalStack>
        </Stack>
      </Box.Body>

      <hr />

      <ShowIf condition={hasAddress}>
        <div>
          <div>Shipping Address:</div>
          <strong>
            <ShippingAddressDisplay />
          </strong>
        </div>
      </ShowIf>
      <hr />

      <ShowIf condition={!isEmpty(customerPoNumber)}>
        <div>
          <div>Purchase Order Number:</div>
          <strong>{customerPoNumber ?? ''}</strong>
        </div>
      </ShowIf>
    </Box>
  )
}
